<template>
    <div class="LinkBanner">
        <CustomLinkBanner
            :to="slice.primary.internal_link.url"
            :href="slice.primary.external_link.url"
            :line_1="slice.primary.line_1_text"
            :line_2="slice.primary.line_2_text"
        />
    </div>
</template>

<script setup lang="ts">
import { type Content } from '@prismicio/client'

// The array passed to `getSliceComponentProps` is purely optional.
// Consider it as a visual hint for you when templating your slice.
defineProps(
    getSliceComponentProps<Content.LinkBannerSlice>([
        'slice',
        'index',
        'slices',
        'context',
    ]),
)
</script>

<style lang="scss">
.TileBlock + .LinkBanner,
.JengaImageGrid + .LinkBanner {
    padding-top: 3rem;

    @include medium-up {
        padding-top: 8rem;
    }
}

.LinkBanner {
    padding-top: 8rem;
    grid-column: 2 / span 22;

    @include medium-up {
        padding-top: 11.25rem;
    }
}
</style>
